/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Global Variables

const params = new URLSearchParams(window.location.search);

// Interactive Before / After Component

function sliderEngage() {
    const parent = this.closest('.int-results--parent');
    if (!parent) return;
    const beforeImage = parent.querySelector('.before-image');
    if (!beforeImage) return;
  
    const pct = Math.max(0, Math.min(100, this.value / 10)); // clamp 0–100
    beforeImage.style.clipPath = `polygon(0 0, ${pct}% 0, ${pct}% 100%, 0% 100%)`;
  }
  
  function sliderEngageRAF(e) {
    // avoid layout thrash on rapid input
    if (this.__raf) cancelAnimationFrame(this.__raf);
    this.__raf = requestAnimationFrame(() => sliderEngage.call(this, e));
  }
  
  function stopEvtPropagation(el) {
    ['pointerdown','pointermove','pointerup','pointercancel','touchstart','touchmove','touchend','mousedown','mousemove','mouseup','click']
      .forEach(evt => el.addEventListener(evt, e => e.stopPropagation(), { passive: true }));
  }
  
  function wireSliderAgainstFlickity(slider) {
    const viewport = slider.closest('.flickity-viewport');
    const flk = viewport && viewport.parentElement
      ? (viewport.parentElement.flickityInstance || viewport.parentElement.__flkty || null)
      : null;
  
    stopEvtPropagation(slider);
  
    if (flk) {
      const unbind = () => { try { flk.unbindDrag && flk.unbindDrag(); } catch(_){} };
      const bind   = () => { try { flk.bindDrag && flk.bindDrag(); } catch(_){} };
  
      slider.addEventListener('pointerdown', unbind, { passive: true });
      slider.addEventListener('touchstart',  unbind, { passive: true });
      slider.addEventListener('mousedown',   unbind);
  
      const rebind = () => bind();
      ['pointerup','pointercancel','touchend','mouseup','mouseleave','blur']
        .forEach(evt => slider.addEventListener(evt, rebind, { passive: true }));
    }
  }
  
  function initResultsComponent() {
    const sliders = document.querySelectorAll('input[type="range"][data-component-type="results-slider"]');
    sliders.forEach(slider => {
      wireSliderAgainstFlickity(slider);             // <-- you missed this call
      slider.addEventListener('input', sliderEngageRAF);
      slider.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
  
  document.addEventListener('DOMContentLoaded', initResultsComponent);
  

// Provider locator - launch form

function launchLocator(evt) {
    evt.preventDefault();
    let parent = this.closest('[data-component-type="locator-form-parent"]');
    let inputValue = parent.querySelector('[name="zip-input"]').value;
    let destinationUrl= "/pages/find-a-provider?location=" + inputValue;
    window.location = destinationUrl;
}

function initLocatorLaunch() {
    let locatorTriggers = document.querySelectorAll('[data-component-type="launch-locator"]');
    locatorTriggers.forEach(trigger => {
        trigger.addEventListener('click', launchLocator)
    })
}

document.addEventListener('DOMContentLoaded', initLocatorLaunch)
